<app-cabecalho [data]="data.CABECALHO"></app-cabecalho>
<app-descricao [data]="data.DESCRICAO"></app-descricao>

<app-detalhes [data]="data.DESAFIOS"></app-detalhes>

<div class="container">
    <div class="divider"></div>
</div>

<app-resultados [data]="data.RESULTADOS"></app-resultados>